import { useContext } from 'react';

import { FileUploadContext } from 'common/contexts/FileUploadContext';

export const useFileUpload = () => useContext(FileUploadContext);
